import { render, staticRenderFns } from "./ImportMigrationCSV.vue?vue&type=template&id=3bfd53af"
import script from "./ImportMigrationCSV.vue?vue&type=script&lang=js"
export * from "./ImportMigrationCSV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports